var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TableBasicPreview',{attrs:{"data":_vm.tableData}})
}
var staticRenderFns = []

export { render, staticRenderFns }